import validate from "/builds/rialtic/qa/argocd-releases/console-ui/node_modules/.pnpm/nuxt@3.17.7_4953a0120366cb5c2b35ab0e0c80d924/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45required_45global from "/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/middleware/auth-required.global.ts";
import _02_45rbac_45global from "/builds/rialtic/qa/argocd-releases/console-ui/apps/disputes/middleware/02.rbac.global.ts";
export const globalMiddleware = [
  validate,
  _01_45auth_45required_45global,
  _02_45rbac_45global
]
export const namedMiddleware = {
  "claim-lab": () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/claim-lab/middleware/claim-lab.ts")
}